(() => {
    const key = 'almaVennWishlist';
    const heart = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M20.8 4.7a5.5 5.5 0 0 0-7.8 0L12 5.8l-1.1-1.1a5.5 5.5 0 0 0-7.8 7.8l1.1 1.1L12 21l7.8-7.4 1.1-1.1a5.5 5.5 0 0 0-.1-7.8Z"/></svg>';

    const read = () => {
      try {
        const value = JSON.parse(localStorage.getItem(key) || '[]');
        return Array.isArray(value) ? value : [];
      } catch {
        return [];
      }
    };

    const write = (items) => {
      try {
        localStorage.setItem(key, JSON.stringify(items));
        document.dispatchEvent(new CustomEvent('alma:wishlist'));
        return true;
      } catch {
        return false;
      }
    };

    const createDialog = () => {
      if (document.querySelector('.alma-wishlist-dialog')) return;
      const dialog = document.createElement('dialog');
      dialog.className = 'alma-wishlist-dialog';
      dialog.setAttribute('aria-labelledby', 'AlmaWishlistTitle');
      dialog.innerHTML = '<div class="alma-wishlist-dialog__header"><h2 id="AlmaWishlistTitle">Saved pieces</h2><button class="alma-wishlist-dialog__close" type="button" aria-label="Close wishlist">×</button></div><div class="alma-wishlist-dialog__body"><div class="alma-wishlist-content"></div></div>';
      document.body.appendChild(dialog);
      dialog.querySelector('.alma-wishlist-dialog__close').addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) dialog.close();
      });
    };

    const renderDialog = () => {
      createDialog();
      const content = document.querySelector('.alma-wishlist-content');
      if (!content) return;
      const items = read();
      content.replaceChildren();
      if (!items.length) {
        const empty = document.createElement('p');
        empty.textContent = 'Save pieces while you browse and they will stay here on this device.';
        content.appendChild(empty);
        return;
      }
      const list = document.createElement('ul');
      list.className = 'alma-wishlist-list';
      items.forEach((item) => {
        const row = document.createElement('li');
        row.className = 'alma-wishlist-item';
        if (item.image) {
          const image = document.createElement('img');
          image.src = item.image;
          image.alt = '';
          image.loading = 'lazy';
          row.appendChild(image);
        } else {
          const space = document.createElement('span');
          space.setAttribute('aria-hidden', 'true');
          row.appendChild(space);
        }
        const link = document.createElement('a');
        link.href = item.url;
        link.textContent = item.title;
        row.appendChild(link);
        const remove = document.createElement('button');
        remove.type = 'button';
        remove.textContent = 'Remove';
        remove.addEventListener('click', () => write(read().filter((saved) => saved.url !== item.url)));
        row.appendChild(remove);
        list.appendChild(row);
      });
      content.appendChild(list);
    };

    const updateHeaderCount = (items) => {
      document.querySelectorAll('.alma-wishlist-count').forEach((count) => {
        const nextCount = String(items.length);
        if (count.textContent !== nextCount) count.textContent = nextCount;
        count.hidden = items.length === 0;
      });
    };

    const update = () => {
      const items = read();
      updateHeaderCount(items);
      document.querySelectorAll('.alma-card-wishlist').forEach((button) => {
        const active = items.some((item) => item.url === button.dataset.url);
        button.setAttribute('aria-pressed', String(active));
        button.setAttribute('aria-label', active ? 'Remove from saved pieces' : 'Save this piece');
      });
      renderDialog();
    };

    const addHeaderButton = () => {
      const icons = document.querySelector('.header__icons');
      if (!icons || icons.querySelector('.alma-wishlist-trigger')) return;
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'header__icon alma-wishlist-trigger';
      button.setAttribute('aria-label', 'Open saved pieces');
      button.innerHTML = heart + '<span class="alma-wishlist-count" hidden>0</span>';
      button.addEventListener('click', () => {
        renderDialog();
        const dialog = document.querySelector('.alma-wishlist-dialog');
        if (dialog && typeof dialog.showModal === 'function') dialog.showModal();
      });
      const cart = icons.querySelector('.header__icon--cart');
      icons.insertBefore(button, cart || null);
    };

    const addCardButtons = (root = document, items = read()) => {
      const cards = new Set();
      const closestCard = root.closest?.('.card-wrapper');
      if (closestCard) cards.add(closestCard);
      if (root.matches?.('.card-wrapper')) cards.add(root);
      root.querySelectorAll?.('.card-wrapper').forEach((card) => cards.add(card));

      cards.forEach((card) => {
        if (card.querySelector('.alma-card-wishlist')) return;
        const link = card.querySelector('.card__heading a, a.full-unstyled-link');
        if (!link || !link.href.includes('/products/')) return;
        const image = card.querySelector('.card__media img');
        const item = {
          url: new URL(link.href, window.location.origin).pathname,
          title: link.textContent.trim(),
          image: image ? image.currentSrc || image.src : ''
        };
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'alma-card-wishlist';
        button.dataset.url = item.url;
        const active = items.some((saved) => saved.url === item.url);
        button.setAttribute('aria-pressed', String(active));
        button.setAttribute('aria-label', active ? 'Remove from saved pieces' : 'Save this piece');
        button.innerHTML = heart;
        button.addEventListener('click', (event) => {
          event.preventDefault();
          const items = read();
          const exists = items.some((saved) => saved.url === item.url);
          const saved = write(exists ? items.filter((savedItem) => savedItem.url !== item.url) : [...items, item]);
          if (!saved) button.setAttribute('aria-label', 'Saved pieces are unavailable in this browser');
        });
        card.prepend(button);
      });
    };

    const init = () => {
      createDialog();
      addHeaderButton();
      addCardButtons();
      update();
      const observer = new MutationObserver((records) => {
        const items = read();
        addHeaderButton();
        updateHeaderCount(items);
        records.forEach((record) => {
          record.addedNodes.forEach((node) => {
            if (node.nodeType === Node.ELEMENT_NODE) addCardButtons(node, items);
          });
        });
      });
      observer.observe(document.body, { childList: true, subtree: true });
    };

    document.addEventListener('alma:wishlist', update);
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init, { once: true });
    } else {
      init();
    }
  })();
